import React from "react";
import Image from "next/image";

interface SectionHeaderProps {
  title: string;
  score: number;
  maxScore: number;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  score,
  maxScore,
}) => {
  return (
    <div className="mb-8 lg:mb-10 xl:mb-16 flex lg:hidden lg:mt-0 lg:p-0 w-full items-start justify-between">
      <div className="flex gap-10 items-center justify-center">
        <Image
          src="/icons/backArrow.svg"
          width={50}
          height={50}
          alt="arrow"
          className=" lg:h-10 lg:w-10 h-[40px] w-[20px] absolute left-[13px] lg:left-[27px] top-[-10px] cursor-pointer text-gray-600 p-1 py-2 lg:p-2 bg-[#f1f1f1] rounded-xl"
          onClick={() => window.history.back()}
        />
        <span className="text-base absolute sm:text-sm md:text-lg lg:text-[25px] py-2 px-8 left-[40px] lg:left-[94px] top-[-10px] bg-[#f1f1f1] rounded-xl font-semibold">
          {title}
        </span>
      </div>
      <span className="rounded-xl absolute top-[-10px] px-6 right-[30px] lg:right-[200px] bg-[#f1f1f1] text-[24px] py-2 text-base sm:text-sm md:text-base lg:text-[20px] font-medium text-black">
        <span className={`
          ${(score / maxScore) > 0.75 ? 'text-green-800' : ''}
          ${(score / maxScore) >= 0.4 && (score / maxScore) <= 0.75 ? 'text-orange-700' : ''}
          ${(score / maxScore) < 0.4 ? 'text-[#F34747]' : ''}h-10 w-10
        `}>{score}</span>/<span className="text-[#8779FD] ">{maxScore}</span>
      </span>
    </div>
  );
};